import { Button, Col, Form, Modal, Row } from "antd";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { CloseOutlined } from "@ant-design/icons";
import { RiExportFill } from "react-icons/ri";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import useGet from "../../../global/hooks/useGet";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { useEffect, useState } from "react";
import usePost from "../../../global/hooks/usePost";
import downloadCsv from "../../../global/utils/downloadCsv";
import dayjs from "dayjs";

export const DeviceActReportForm = ({ url, modalOpen, setModalOpen }) => {
  const [form] = Form.useForm();
  const [OemNo, setOemNo] = useState(null);
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
    // ProductionNo: null,
  });

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const {
    data: exportData,
    postData,
    error: postError,
    loading: postLoading,
  } = usePost(url);

  const dealerOptionsUrl =
    OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          OemNo ? OemNo : defaultData?.OemNo ? defaultData.OemNo : null
        }/dealers/`
      : null;
  const {
    data: dealerOp,
    loading: delaerOpLoading,
    error: dealerOpError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const handleExportClick = async (values) => {
    const modifiedValues = {
      ...values,
      month: new Date(values.month).toISOString().slice(0, 7),
    };
    try {
      await postData(modifiedValues);
      // setShouldFetch(true);
    } catch (error) {
      console.error(error);
      openErrorNotification("Something went wrong.");
    }
  };

  useEffect(() => {
    if (!form.getFieldValue("month")) {
      form.setFieldValue("month", dayjs());
    }
  }, []);

  useEffect(() => {
    delaerOpRefetch();
  }, [OemNo]);

  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong.",
      );
    } else if (postData && !postLoading) {
      if (exportData?.message === "No devices found.") {
        return openErrorNotification("No Data Found");
      }
      setTimeout(() => {
        if (exportData) {
          const location = window.location;
          downloadCsv(exportData, location);
          openConfirmNotification("Success");
        }
      }, 100);

      // openConfirmNotification("Success");
      // setExportModal(false); // Close the modal on success
    }
  }, [exportData, postError, postLoading]);

  return (
    <Modal
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <RiExportFill className="text-[20px] text-black pl-1 " />
          <span className="text-[14px] font-[Poppins]   ml-2">
            <p>Activation Report</p>
          </span>
        </div>
      }
      open={modalOpen}
      closable={false}
      onCancel={() => {
        setModalOpen(false);
        setDefaultData({
          DealerNo: null,
          OemNo: null,
          CustomerNo: null,
          // ProductionNo: null,
        });
        setOemNo(null);
        form.resetFields();
      }}
      footer={null}
      width={580}
      centered
      destroyOnClose
      onClose={() => {
        setDefaultData({
          DealerNo: null,
          OemNo: null,
          CustomerNo: null,
          // ProductionNo: null,
        });
        setOemNo(null);
        form.resetFields();
      }}
    >
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={(values) => {
          setTimeout(() => {
            handleExportClick(values);
          }, 200);
        }}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div className="bg-white rounded-[4px] overflow-hidden">
          <div className="px-2 pt-1 pb-3">
            <Row gutter={[0, 0]}>
              <Col span={24}>
                <CustomSelect
                  label="OEM"
                  name="oem_no"
                  options={modifiedOems}
                  // disabled={type === "info" || accountDefaultData?.OemNo}
                  placeholder="Please select"
                  onChange={(value) => {
                    setDefaultData((prev) => ({
                      ...prev,
                      OemNo: value,
                      DealerNo: null,
                    }));
                    setOemNo(value);
                    // setDealerNo(null);
                    form.setFieldsValue({
                      DealerNo: null,
                    });
                  }}
                  required
                  // handleCreateNew={
                  //   accountDefaultData?.OemNo ? null : handleCreateNew
                  // }
                  type={"OEM"}
                  // loading={loading}
                />
              </Col>
              <Col span={24}>
                <CustomSelect
                  label="Dealer"
                  name="DealerNo"
                  required
                  options={
                    dealerOp?.data?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    })) || []
                  }
                  disabled={
                    // defaultData?.OemNo
                    //   ? !defaultData?.OemNo
                    //   : accountDefaultData?.OemNo
                    //   ? !accountDefaultData?.OemNo
                    //   : !selectedOemNo ||
                    defaultData?.OemNo ? !defaultData?.OemNo : !OemNo
                  }
                  placeholder="Please select"
                  onChange={(value) => {
                    setDefaultData((prev) => ({
                      ...prev,
                      DealerNo: value,
                    }));
                    // setDealerNo(value);
                    // form.setFieldsValue({
                    //   CustomerNo: null,
                    // });
                  }}
                  // handleCreateNew={handleCreateNew}
                  type={"Dealer"}
                />
              </Col>
              <Col span={24}>
                <CustomDateTimePicker
                  name="month"
                  label="Month"
                  placeholder="Please select"
                  picker={"month"}
                  required
                  disableFuture
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
            loading={postLoading}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button
            className="reset-button"
            onClick={() => {
              setModalOpen(false);
              setDefaultData({
                DealerNo: null,
                OemNo: null,
                CustomerNo: null,
                // ProductionNo: null,
              });
              setOemNo(null);
              form.resetFields();
            }}
          >
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
